<app-offline [online]="online()"></app-offline>
<app-online [online]="online()"></app-online>
<router-outlet></router-outlet>
